import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

export function SvgBell(props) {
  const theme = useTheme();
  const { width, height, stroke = theme.colors.secondary } = props;
  return (
    <svg width={width || '14px'} height={height || '16px'} viewBox="0 0 14 16" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-856.000000, -22.000000)" strokeWidth="2">
          <g>
            <g transform="translate(851.000000, 18.000000)" stroke={stroke}>
              <path d="M18.6666667,15.3333334 L5.33333333,15.3333334 C6.43790283,15.3333334 7.33333333,14.4379028 7.33333333,13.3333334 L7.33333333,10 C7.33333333,7.42267119 9.42267119,5.3333334 12,5.3333334 C14.5773288,5.3333334 16.6666666,7.42267119 16.6666667,10 L16.6666667,13.3333334 C16.6666667,14.4379028 17.5620972,15.3333334 18.6666667,15.3333334 L18.6666667,15.3333334 Z M13.1533333,18 C12.9148015,18.4112029 12.4753791,18.6643042 12,18.6643042 C11.5246209,18.6643042 11.0851985,18.4112029 10.8466667,18 L13.1533333,18 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgBell.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
